import { SelectText } from '@airtm/airtm-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  endOfMonth,
  format,
  getDate,
  getMonth,
  getYear,
  parseISO,
  setDate,
  setMonth,
  setYear,
} from 'date-fns';
import range from 'lodash.range';
import toOption from 'utils/toOption';
import { LOCALES } from '@constants';

const getUTCDate = (date = new Date()) => {
  return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
};

export default function SelectBirthDate({
  values = {},
  setFieldValue,
  setTouched,
  label,
  invalid,
  ...otherProps
}) {
  const { i18n } = useTranslation();
  const birthDate = getUTCDate(parseISO(values.birthDate));

  return (
    <>
      {label && (
        <div className="row mb-1">
          <div className="col">
            <span className="select-custom__label select-custom__label--active">{label}</span>
          </div>
        </div>
      )}
      <div className="row align-items-end">
        <div className="col">
          <SelectText
            id="date"
            onChange={({ value }) => {
              setFieldValue('birthDate', format(setDate(birthDate, value), 'yyyy-MM-dd'));
            }}
            options={range(1, getDate(endOfMonth(birthDate)) + 1).map((date) => toOption(date))}
            value={`${getDate(birthDate)}`}
            invalid={invalid}
            {...otherProps}
          />
        </div>
        <div className="col">
          <SelectText
            id="month"
            onChange={({ value }) => {
              setFieldValue('birthDate', format(setMonth(birthDate, value), 'yyyy-MM-dd'));
            }}
            options={range(0, 12).map((month) =>
              toOption(
                month,
                format(setMonth(new Date(), month), 'MMMM', { locale: LOCALES[i18n.language] }),
              ),
            )}
            value={`${getMonth(birthDate)}`}
            invalid={invalid}
            {...otherProps}
          />
        </div>
        <div className="col">
          <SelectText
            id="year"
            onChange={({ value }) => {
              setTouched({ birthDate: true });
              setFieldValue('birthDate', format(setYear(birthDate, value), 'yyyy-MM-dd'));
            }}
            options={range(getYear(new Date()), 1899, -1).map((year) => toOption(year))}
            value={`${getYear(birthDate)}`}
            invalid={invalid}
            {...otherProps}
          />
        </div>
        <input id="birthDate" name="birthDate" type="hidden" value={values.birthDate} />
      </div>
    </>
  );
}

SelectBirthDate.propTypes = {
  setTouched: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,

  values: PropTypes.object,
};
